import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useForm } from 'react-hook-form';

import { JVInput } from "../../shared/JVInput";
import { Fetch } from "../../shared/Fetch";
import { IBranchMastDropdown } from "../../models/IDropdown";
import { JVDropdown } from "../../shared/JVDropdown";
import { useEffect, useState } from "react";


export interface IFilterEmpDlts {

    emp_Name?: string | null,
    email?: string | null,
    branch?: string | null
}

export const IEmptyFilterEmp = {
    emp_Name: null,
    email: null,
    branch: null

}

interface Iprops {
    // open: boolean,
    // hideDialog: () => void,
    // toast: any,
    filters: IFilterEmpDlts,
    setFilters: (filters: IFilterEmpDlts) => void,
}
export const Filter = (props: Iprops) => {

    const [branch, setBranch] = useState<Array<IBranchMastDropdown>>();

    const loadBranch = async () => {
        const response = await Fetch("Dropdown/Branches", "GET", null, null, null);
        if (response) {
            const data: Array<IBranchMastDropdown> = await response.json();
            const emptyData = {
                branch_ID: 0,
                branchName: "-- SELECT --",
                company_ID: 0
            };
            data.unshift(emptyData);
            setBranch(data);
        }
    }

    useEffect(() => {
        loadBranch();
    }, []);

    const { control, handleSubmit, reset } = useForm<IFilterEmpDlts>({
        defaultValues: IEmptyFilterEmp,
        shouldFocusError: false
    });



    const searchToDB = async (body: IFilterEmpDlts) => {
        // onHide();
        let filterData: any = body;
        let emptyFilter: any = IEmptyFilterEmp;
        for(let key in filterData){
            if(filterData[key] === "-- SELECT --" || filterData[key] === 0){
                filterData[key] = emptyFilter[key];
            }
        }
        body = filterData;
        props.setFilters(body);
    }

    // const onHide = () => {
    //     props.hideDialog();
    // }

    function onSubmit(data: IFilterEmpDlts) {
        searchToDB(data);
    }
    return (

        // <Dialog visible={props.open} style={{ width: '80vw' }} header="Search Requirement" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVInput column={6} label="Emp Name" type="text" control={control} name="emp_Name" />
                <JVInput column={6} label="Email " type="email" control={control} name="email" />
                <JVDropdown column={3} label="Branch Name " control={control} name="branch" options={branch} optionLabel="branchName" optionValue="branch_ID" placeholder="Select Branch Name" />

                <div style={{ margin: '10px 0', width: '100%' }}></div>
                <div className="col-12 md:col-12" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '10px' }}>
                    <Button className="field col-12 md:col-6" label="SEARCH" type="submit"></Button>
                    <Button className="field col-12 md:col-6 p-button-outlined" label="CLEAR" onClick={() => { reset(IEmptyFilterEmp) }} type="button"></Button>
                </div>
            </form>

    )
}